module.exports = __webpack_public_path__ + "img/au.53942d2f.svg";